<template>
  <div v-if="shouldShow">
    <header class="search-competences-suggestions__header">
      <af-h3>Föreslagna kompetenser</af-h3>
      <ul class="search-competences-suggestions__tags">
        <li
          v-for="e in experiences"
          :key="e.path">{{ e.name }}</li>
      </ul>
    </header>
    <section class="search-competences-suggestions__options">
      <div class="search-competences-suggestions__options-option"
        v-for="competence in competences" :key="`suggestions-${competence.path}`">
        <af-checkbox
          :checked="isAdded(competence.path)"
          :label="competence.name"
          :name="competence.path"
          @changed="toggleInclude($event)">
          {{ competence.name }}
        </af-checkbox>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import gql from 'graphql-tag'
import AfH3 from '@/components/AfH3'
import AfCheckbox from '@/components/AfCheckbox'
import { filterDuplicates } from '@/utils/helpers'
import * as types from '@/store/actionTypes'

export default {
  name: 'SearchCompetencesSuggestions',

  components: {
    AfH3,
    AfCheckbox
  },

  data() {
    return {
      competences: []
    }
  },

  computed: {
    ...mapState({
      experiences: state => state.query.experiences,
      skills: state => state.query.skills
    }),
    shouldShow() {
      return this.experiences.length && this.competences.length
    }
  },
  apollo: {
    suggestionsData: {
      query: gql`
        query CompetencesForProcessions($language: LanguageCode, $paths: [String!]) {
          competencesForProfessions(language: $language, paths: $paths) {
            name
            path
            type
          }
        }
      `,
      loadingKey: 'loading',
      variables() {
        return {
          language: 'sv',
          paths: this.handleExperiences()
        }
      },
      update({ competencesForProfessions }) {
        const unfilteredCompetences = [...competencesForProfessions]
        this.competences = filterDuplicates(unfilteredCompetences)
      }
    }
  },

  methods: {
    handleExperiences() {
      return this.experiences.map(experience => experience.path)
    },
    isAdded(competencePath) {
      const exists = this.skills.find(skill => skill.path === competencePath)
      return exists ? true : false
    },
    toggleInclude(path) {
      const skillAlreadyAdded = this.skills.find(skill => skill.path === path)

      if (!skillAlreadyAdded) {
        this.addCompetence(path)
      } else {
        this.removeCompetence(path)
      }
    },
    addCompetence(path) {
      const years = [
        {
          modifier: 'gte',
          years: 0
        }
      ]

      const competenceToAdd = this.competences.find(
        competence => competence.path === path
      )
      if (!competenceToAdd) {
        return
      }

      const payload = {
        years,
        path,
        name: competenceToAdd.name
      }

      this.$store.commit(types.ADD_TO_QUERY, {
        payload,
        type: 'skills'
      })

      window.eventBus.$emit('openExpansionPanel', {
        ...payload,
        type: 'skills'
      })
    },
    removeCompetence(path) {
      const payload = { type: 'skills', path }

      window.eventBus.$emit('removeTag', payload)
      this.$store.commit(types.REMOVE_FROM_QUERY, payload)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-competences-suggestions__header {
  display: flex;
  margin-bottom: var(--spacing-medium);
  margin-left: var(--spacing-half);
  margin-top: var(--spacing-half);

  @media (--bp-nis-extra-small) {
    flex-direction: column;
  }
}

.search-competences-suggestions__tags {
  display: flex;
  flex-wrap: wrap;

  @media (--bp-nis-small) {
    margin-left: 25px;
    margin-top: -10px;
  }

  & li {
    border-radius: 4px;
    background: var(--color-porcelain);
    color: var(--color-black);
    font-weight: 600;
    font-size: 14px;
    margin: 0 5px 5px 0;
    padding: 10px;
  }
}

.search-competences-suggestions__options {
  align-items: center;
  background: var(--color-porcelain);
  display: grid;
  grid-auto-rows: 58px;
  grid-column-gap: var(--spacing-half);
  grid-template-columns: 1fr;
  margin-bottom: var(--spacing-medium);
  padding-left: var(--spacing-third);
  padding-right: var(--spacing-third);

  @media (--bp-nis-small) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.search-competences-suggestions__options-option {
  padding: var(--spacing-third) var(--spacing-half) var(--spacing-third)
    var(--spacing-third);
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchCompetencesSuggestions.vue